import gql from 'graphql-tag';

import type { TaskResponse } from 'common/components/TasksWidget/queries';
import { TaskFragment } from 'common/components/TasksWidget/queries';

export const getMyTasks = gql`
  query getMyTasks($startedBy: BinaryId, $id: [BinaryId!], $fetch: Boolean!, $sync: Boolean!) {
    tasks(startedBy: $startedBy, active: true) @include(if: $fetch) {
      ...Task
    }

    sync: tasks(id: $id) @include(if: $sync) {
      ...Task
    }
  }

  ${TaskFragment}
`;

export type MyTasksResponse = {
  tasks: TaskResponse[];
  sync: TaskResponse[];
};
